 const Shimmer=()=>{
   return(
    <div>
    <div className="body">
    <div className="flex flex-wrap bg-zinc-100 my-auto">
    <div 
          data-testid="searchCard"
          className="p-4 border-2 m-5 w-72 h-52 overflow-hidden  rounded-lg hover:bg-green-300"
          >
   <h3 className="font-bold"> </h3>
   <h4 className="text-left"></h4>
  <h4 className="italic"></h4>
  <h4></h4> 
  <h4 className="font-bold"></h4>
  <h4></h4>
  <h4></h4> 
  </div>
  <div 
          data-testid="searchCard"
          className="p-4 border-2 m-5 w-72 h-52 overflow-hidden  rounded-lg hover:bg-green-300"
          >
   <h3 className="font-bold"> </h3>
   <h4 className="text-left"></h4>
  <h4 className="italic"></h4>
  <h4></h4> 
  <h4 className="font-bold"></h4>
  <h4></h4>
  <h4></h4> 
  </div>
  <div 
          data-testid="searchCard"
          className="p-4 border-2 m-5 w-72 h-52 overflow-hidden  rounded-lg hover:bg-green-300"
          >
   <h3 className="font-bold"> </h3>
   <h4 className="text-left"></h4>
  <h4 className="italic"></h4>
  <h4></h4> 
  <h4 className="font-bold"></h4>
  <h4></h4>
  <h4></h4> 
  </div>
  </div>
  
</div>
<div className="flex flex-wrap bg-zinc-100 my-auto">
    <div 
          data-testid="searchCard"
          className="p-4 border-2 m-5 w-72 h-52 overflow-hidden  rounded-lg hover:bg-green-300"
          >
   <h3 className="font-bold"> </h3>
   <h4 className="text-left"></h4>
  <h4 className="italic"></h4>
  <h4></h4> 
  <h4 className="font-bold"></h4>
  <h4></h4>
  <h4></h4> 
  </div>
  <div 
          data-testid="searchCard"
          className="p-4 border-2 m-5 w-72 h-52 overflow-hidden  rounded-lg hover:bg-green-300"
          >
   <h3 className="font-bold"> </h3>
   <h4 className="text-left"></h4>
  <h4 className="italic"></h4>
  <h4></h4> 
  <h4 className="font-bold"></h4>
  <h4></h4>
  <h4></h4> 
  </div>
  <div 
          data-testid="searchCard"
          className="p-4 border-2 m-5 w-72 h-52 overflow-hidden  rounded-lg hover:bg-green-300"
          >
   <h3 className="font-bold"> </h3>
   <h4 className="text-left"></h4>
  <h4 className="italic"></h4>
  <h4></h4> 
  <h4 className="font-bold"></h4>
  <h4></h4>
  <h4></h4> 
  </div>
  
  
</div>
</div>

   );
};
export default Shimmer;